const InfoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 13 13"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M6.5 11.167a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334zM6.5 8.367V6.5M6.5 4.633h.004"
    />
  </svg>
);

export default InfoSvg;
